import React from 'react';

export const useScroller = (scrollable) => {
  const scrollableElement = scrollable?.current;
  const [top, setTop] = React.useState(scrollableElement?.scrollTop || 0);
  const [left, setLeft] = React.useState(scrollableElement?.scrollLeft || 0);

  const handleScroll = () => {
    setTop(scrollableElement.scrollTop);
    setLeft(scrollableElement.scrollLeft);
  };

  React.useEffect(() => {
    if (scrollableElement) {
      scrollableElement.addEventListener('scroll', handleScroll);

      return () => scrollableElement.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return {
    top,
    left,
  };
};
